import { render, staticRenderFns } from "./placeholder-editor.vue?vue&type=template&id=27577ea4&scoped=true"
import script from "./placeholder-editor.vue?vue&type=script&lang=js"
export * from "./placeholder-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27577ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27577ea4')) {
      api.createRecord('27577ea4', component.options)
    } else {
      api.reload('27577ea4', component.options)
    }
    module.hot.accept("./placeholder-editor.vue?vue&type=template&id=27577ea4&scoped=true", function () {
      api.rerender('27577ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/placeholder-editor.vue"
export default component.exports